import { IAppState } from "./interface";
import { appSettings } from "./states/appSettings";
import { user } from "./states/user";

/**
 * App State Model
 */
export const appModel: IAppState = {
  user,
  appSettings
}